"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JPosScrollCommand = void 0;
const JPosScrollDirection_1 = require("../../common/JPosScrollDirection");
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Linearly transition cursor's position to a different position on a bar. Can
 * be placed in the middle of a measure.
 *
 * **Example:**
 *
 * ```
 * #BPMCHANGE 120
 * #JPOSSCROLL 2 760 1
 * #SCROLL 0.8
 * 1111,
 * #JPOSSCROLL 2 760 0
 * #SCROLL -0.8
 * 2222,
 * ```
 */
class JPosScrollCommand extends Command_1.Command {
    constructor(time, distance, direction) {
        super(CommandType_1.CommandType.JPosScroll);
        this.time = time;
        this.distance = distance;
        this.direction = direction;
    }
    static parse(args) {
        if (args.length !== 3) {
            return undefined;
        }
        const time = parseFloat(args[0]);
        if (isNaN(time)) {
            return undefined;
        }
        const distance = parseFloat(args[1]);
        if (isNaN(distance)) {
            return undefined;
        }
        const direction = JPosScrollDirection_1.JPosScrollDirection.fromRaw(args[2]);
        if (!direction) {
            return undefined;
        }
        return new JPosScrollCommand(time, distance, direction);
    }
    toString() {
        return `${super.toString()} ${this.time} ${this.distance} ${this.direction}`;
    }
}
exports.JPosScrollCommand = JPosScrollCommand;
